// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"jVbfUAFt"};